module.exports = __webpack_public_path__ + "static/media/bell_icon.1ad5cbf8.svg";